import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../shared/auth/useAuth.js';
import { useTranslation } from '../../shared/i18n/useLanguage.js';
import { AuthForm } from './AuthForm.js';

export function RegisterPage(): ReactElement {
  const { signUp } = useAuth();
  const t = useTranslation();

  return (
    <AuthForm
      title={t.auth.registerTitle}
      submitLabel={t.auth.registerSubmit}
      passwordHint={t.auth.passwordHint}
      onSubmit={signUp}
      footer={
        <>
          {t.auth.alreadyRegistered}
          <Link to="/login">{t.auth.signInLink}</Link>.
        </>
      }
    />
  );
}
